import {
  ActionPendingCatalog,
  PendingResourcesType,
  StatusPendingCatalog,
} from 'src/app/common/enumerations/enumerations';
import { AcceleratorCatalog } from '../../components/catalogs/accelerator-catalog/services/accelerator-catalog';
import { User } from '../../components/catalogs/user-catalog/services/user';
import { ModifyingResult } from '../../components/catalogs/services/catalog-model';
import { BeamlineShutterRelation } from 'src/app/components/catalogs/beamline-catalog/resource/resources';

export class PendingAccelerator {
  id!: number;
  acceleratorId!: number;
  acceleratorName!: string;
  createdBy!: number;
  statusBy!: number;
  statusByUser?: User;
  createdOn!: Date;
  statusOn!: Date;
  disapprovalReason!: string;
  acceleratorData!: string;
  acceleratorCatalog!: AcceleratorCatalog;
  status!: number;
  action!: number;
  statusName!: string;
  actionName!: string;
  userCreatedBy?: User;
  hasResourceChanges?: boolean;
  approvedBy?: number;
  approvedOn?: Date;
  hasShieldingChanges?: boolean;
  shieldingApprovedBy?: number;
  shieldingApprovedOn?: Date;
}

export class PendingResource {
  id!: number;
  resourceId!: number;
  resourceName!: string;
  beamlineName!: string;
  shutterName!: string;
  createdBy!: number;
  statusBy!: number;
  statusByUser?: User;
  createdOn!: Date;
  statusOn!: Date;
  disapprovalReason!: string;
  resourceData!: string;
  resourceTypeId!: number;
  status!: number;
  action!: number;
  statusName!: string;
  actionName!: string;
  userCreatedBy?: User;
  type!: PendingResourcesType;
  hasResourceChanges?: boolean;
  approvedBy?: number;
  approvedOn?: Date;
  hasShieldingChanges?: boolean;
  shieldingApprovedBy?: number;
  shieldingApprovedOn?: Date;

}

export class PendingUser {
  id!: number;
  userId!: number;
  userName?: string;
  createdBy!: number;
  statusBy!: number;
  statusByUser?: User;
  createdOn!: Date;
  statusOn!: Date;
  disapprovalReason!: string;
  userData!: string;
  status!: number;
  action!: number;
  statusName!: string;
  actionName!: string;
  userCreatedBy!: User;
}

// export class PendingRole {
//   id!: number;
//   name!: string;
//   roleId!: number;
//   roleName!: string;
//   roleCode!: string;
//   createdBy!: number;
//   statusBy!: number;
//   statusByUser?: User;
//   createdOn!: Date;
//   statusOn!: Date;
//   disapprovalReason!: string;
//   roleData!: string;
//   status!: number;
//   action!: number;
//   statusName!: string;
//   actionName!: string;
//   userCreatedBy!: User;
//   show?: boolean;
//   modifyingResult!: ModifyingResult;
//   changes!: string;
// }

export interface PendingRole {
  id: number;
  roleId: number | null;
  roleName: string;
  roleCode: string;
  createdBy: number;
  createdByUser: User;
  createdOn: Date;
  statusBy: number | null;
  statusByUser: User;
  statusOn: Date;
  disapprovalReason: string;
  roleData: string;
  status: StatusPendingCatalog;
  action: ActionPendingCatalog;
  show: boolean;
  modifyingResult: ModifyingResult;
}

export class PendingNotificationTemplate {
  id!: number;
  notificationTemplateId!: number;
  notificationTemplateName!: string;
  notificationTemplateCode!: string;
  notificationTemplateMessageSubject!: string;
  notificationTemplateMessageBody!: string;
  notificationTemplateSignature!: string;
  createdBy!: number;
  statusBy!: number;
  statusByUser?: User;
  createdOn!: Date;
  statusOn!: Date;
  disapprovalReason!: string;
  notificationTemplateData!: string;
  status!: number;
  action!: number;
  statusName!: string;
  actionName!: string;
  userCreatedBy!: User;
}

export class detailsUsers {
  approverUserName?: string;
  updateUserName?: string;
  approvedOn?: Date | null;
  updatedOn?: Date | null;
}

export class PendingResourceUsers {
  approverId?: number;
  updateById?: number;
  approvedOn?: Date;
  updatedOn?: Date;
}

export interface PendingApprovals {
  pendingAccelerators: PendingCatalog[];
  pendingResources: PendingCatalog[];
  pendingUsers: PendingCatalog[];
  pendingRoles: PendingCatalog[];
  pendingNotificationTemplates: PendingCatalog[];
  pendingRSSDb: PendingCatalog[];
  pendingChecklistTemplates?: PendingCatalog[];
  pendingAPLCategories: PendingCatalog[];
  pendingAPLGroups: PendingCatalog[];
  total?: number;
}

export interface PendingCatalog {
  approvalType: PendingCatalogType;
  pendingID: number;
  id: number;
  name: string;
  createdBy: number;
  createdByUser: User;
  statusBy: number | null;
  statusByUser: User;
  createdOn: string;
  statusOn: string;
  disapprovalReason: string;
  show: boolean;
  status: number;
  statusName: string;
  action: ActionPendingCatalog;
  actionName: string;
  hasResourceChanges?: boolean;
  approvedBy?: number;
  approvedOn?: Date;
  hasShieldingChanges?: boolean;
  shieldingApprovedBy?: number;
  shieldingApprovedOn?: Date;
}

export enum PendingCatalogType {
  Accelerator = 1,
  Beamline = 2,
  User = 3,
  Role = 4,
  NotificationTemplate = 5,
  RSSDb = 6,
  KET = 10,
  ABSI = 11,
  ChecklistTemplate = 12,
  APLCategories = 20,
  APLGroups = 21,
}
